export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Poradniki wideo i pomoc",
    guidesTip: "Poradniki i pomoc",
    availabilityPricesTitle: "Dostępność i ceny",
    hotelCalendarSubtitle: "Dostępność i rezerwacje według pokoi",
    availabilityPricesSubtitle: "Ceny, dostępność i minimalny pobyt",
  },
  maquetaNav: {
    guidesAria: "Poradniki wideo i pomoc",
    guidesTip: "Poradniki i pomoc",
    novedadesAria: "Aktualizacje systemu",
    novedadesTip: "Nowości",
    tourTip: "Nowości: przewodnik",
    tourAria: "Otwórz przewodnik po nowościach",
    backToPanel: "Powrót do panelu",
    accountTitle: "Ustawienia konta",
    agentIaTitle: "Agent AI",
    directBookingsTitle: "Rezerwacje bezpośrednie",
    listingsTitle: "Ustawienia ofert",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Start",
    calendar: "Kalendarz",
    reservations: "Rezerwacje",
    checkins: "Check-in",
    housekeeping: "Sprzątanie",
    channels: "Kanały rezerwacji",
    settings: "Ustawienia",
    settingsDesktopOnly: "Dostępne tylko w wersji na komputer",
    experiences: "Atrakcje",
  },
  register: {
    terms: "Regulamin",
    privacy: "Polityka prywatności",
    loginError: "Błąd logowania.",
  },
  buttonSave: {
    savingRoom: "Zapisywanie pokoju...",
  },
  firstForm: {
    name: "Imię",
    phone: "Telefon",
  },
  final: {
    guestsRegistered: "Zarejestrowani goście",
    registrationsCompleted: "Ukończone rejestracje",
    registrationTime: "Czas rejestracji: ",
    shareRegistrationLink: "Udostępnij link do rejestracji",
  },
  scannerPdf417: {
    captureCode: "Zeskanuj kod",
    focusInstruction: "Wyostrz i zeskanuj kod kreskowy na swoim dokumencie",
  },
  configNotifications: {
    title: "Powiadomienia",
    propertyLabel: "Obiekt",
    phoneInstruction: "Podaj numer telefonu, na który chcesz otrzymywać przez WhatsApp powiadomienia o prośbach o usługi oraz o check-in wykonanych przez gości",
    saveWhatsapp: "Zapisz WhatsApp",
    editWhatsapp: "Edytuj WhatsApp",
    configTitle: "Ustawienia",
    serviceNotifications: "Powiadomienia o usługach",
    checkinNotifications: "Powiadomienia o check-in",
    active: "Wł.",
    inactive: "Wył.",
    whatsappRequired: "Należy podać numer WhatsApp",
    swalTitle: "WhatsApp do powiadomień z Twojego obiektu",
    swalText: "Będziesz otrzymywać wszystkie powiadomienia o zamówionych usługach i o check-in gości ",
    cancel: "Anuluj",
    whatsappAdded: "WhatsApp dodany pomyślnie",
  },
  modalPoliceData: {
    headerSub: "Wprowadź swoje dane dostępowe do systemu",
    closeAria: "Zamknij",
    entityName: "Nazwa instytucji",
    usernamePlaceholder: "Wprowadź nazwę użytkownika",
    passwordPlaceholder: "Wprowadź hasło",
    hide: "Ukryj",
    show: "Pokaż",
    lessorExample: "np. 12345",
    establishmentExample: "np. 67890",
    saving: "Zapisywanie…",
    listingNotFound: "Nie znaleziono powiązanej oferty.",
    saveFailed: "Nie udało się zapisać danych SES Hospedajes.",
  },
  notificaciones: {
    title: "Powiadomienia",
    propertyLabel: "Obiekt",
    phoneInstruction: "Podaj numer telefonu, na który chcesz otrzymywać przez WhatsApp powiadomienia o prośbach o usługi oraz o check-in wykonanych przez gości",
    saveWhatsapp: "Zapisz WhatsApp",
    editWhatsapp: "Edytuj WhatsApp",
    configTitle: "Ustawienia",
    serviceNotifications: "Powiadomienia o usługach",
    checkinNotifications: "Powiadomienia o check-in",
    active: "Wł.",
    inactive: "Wył.",
    whatsappRequired: "Należy podać numer WhatsApp",
    swalTitle: "WhatsApp do powiadomień z Twojego obiektu",
    swalText: "Będziesz otrzymywać wszystkie powiadomienia o zamówionych usługach i o check-in gości ",
    cancel: "Anuluj",
    whatsappAdded: "WhatsApp dodany pomyślnie",
  },
  admins: {
    listTitle: "Lista menedżerów",
    newManager: "Nowy menedżer",
    today: "Dziś",
    thName: "Nazwa",
    thEmail: "E-mail",
    thRegistered: "Zarejestrowano",
    edit: "Edytuj",
    delete: "Usuń",
    userLabel: "Nazwa użytkownika",
    emailLabel: "E-mail",
    passwordLabel: "Hasło",
    cancel: "Anuluj",
    save: "Zapisz",
    createdOk: "Utworzono pomyślnie",
    requestError: "Błąd żądania",
    updatedOk: "Zaktualizowano pomyślnie",
    deletedOk: "Usunięto pomyślnie",
  },
};
